import React, { useState, useEffect } from "react";
import "./EndDayStockCount.css";
// import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
// NOTE: heroicons are no longer used anywhere on this page. All icons
// (sidebar "Boxes" icon, footer arrow icons) are now plain inline <svg>
// markup matching the Replit reference 1:1, instead of the heroicons set.
// Import left commented, not removed, in case it's needed again.
// import {
//   MagnifyingGlassIcon,
//   CubeIcon,
//   ArrowLeftIcon,
//   ArrowRightIcon,
// } from "@heroicons/react/24/outline";
// import Spinner from "../../../components/Spinner";
// import { Box } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
import { PosCustomButton } from "../../../customComponents/PosCustomButton/PosCustomButton";
// import PosCustomIcon from "../../../customComponents/PosCustomIcon/PosCustomIcon";
import { useNavigate } from "react-router-dom";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import usePrint from "../product/hooks/usePrint";
import { useDispatch } from "react-redux";
import { setUSBDevice } from "../product/all-products/redux/Actions/printingDeviceActions";
import {
  closeAllCarts,
  closeDay,
  getStockCountProducts,
  updateStockCount,
  getEndDayReportData,
} from "../../../config/Services";
import { useSnackbar } from "../product/hooks/SnackbarProvider";
import Swal from "sweetalert2";
import CustomerPaginatedTable from "../product/all-products/CustomerV2Preview/Component/CustomComponent/CustomerPaginatedTable";

const EndDayStockCount = ({ navigate }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [stockCounts, setStockCounts] = useState({});
  const [selectedRow, setSelectedRow] = useState([]);
  const showSnackbar = useSnackbar();

  // NEW END DAY MODAL STATES
  const [endDayModalOpen, setEndDayModalOpen] = useState(false);
  const [endDayLoading, setEndDayLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { startPrint } = usePrint();
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    setEndDayModalOpen(false);
  };

  const licenseId = localStorage.getItem("licenseId");
  const sessionId = localStorage.getItem("sessionId");
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const daySessionId = localStorage.getItem("daySessionId");
  const enableMandatoryStockCount = localStorage.getItem("enableMandatoryStockCount") === "true";
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));

  const [pageState, setPageState] = useState({
    loader: false,
    dataRows: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });

  const navigateToPath = useNavigate();

  const newSwal = Swal.mixin({
    customClass: {
      confirmButton: "button button-success",
      cancelButton: "button button-error",
      denyButtonText: "button button-success",
      container: "close-session-swal-container",
    },
    buttonsStyling: false,
  });

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 700);

    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  // API call function
  const getStockCount = async (page = 0, size = 10) => {
    setPageState((old) => ({ ...old, loader: true }));

    try {
      const response = await getStockCountProducts(page, size, daySessionId, debouncedSearchTerm);

      const result = response?.data;

      if (result?.status === "ERROR") {
        showSnackbar(result?.message || "There was an error getting the data", "error");
        setPageState((old) => ({ ...old, loader: false }));
        return;
      }

      if (result?.status === "SUCCESS" && result?.data && Object.keys(result.data).length > 0) {
        if (result?.data?.data?.data) {
          const mappedData = result?.data?.data?.data?.map((item, index) => ({
            id: item?.batchSessionId || `${page * size + index + 1}`,
            productName: item?.itemName,
            uom: item?.sellingUnits,
            batch: item?.batchNumber,
            gtin: item?.gtin,
            inventoryId: item?.inventoryId,
            batchSessionId: item?.batchSessionId,
          }));

          setPageState((old) => ({
            ...old,
            loader: false,
            dataRows: mappedData,
            total: result?.data?.data?.totalResult,
            page: result?.data?.data?.pageNumber + 1,
          }));
        } else {
          // Data exists but no products found
          setPageState((old) => ({
            ...old,
            loader: false,
            dataRows: [],
            total: 0,
          }));
        }
      } else {
        // Empty data object
        setPageState((old) => ({
          ...old,
          loader: false,
          dataRows: [],
          total: 0,
        }));
      }
    } catch (error) {
      setPageState((old) => ({ ...old, loader: false }));
      showSnackbar("There was an error getting the data", "error");
    }
  };

  useEffect(() => {
    getStockCount(pageState.page - 1, pageState.pageSize);
  }, [pageState.page, pageState.pageSize, debouncedSearchTerm]);

  // ── NEW: columns for CustomerPaginatedTable ────────────────────────────────
  const columns = [
    {
      key: "productName",
      label: "Item Name",
      width: "1.6fr",
    },
    {
      key: "batch",
      label: "Batch Number",
      width: "1fr",
    },
    {
      key: "gtin",
      label: "GTIN",
      width: "1fr",
    },

    {
      key: "uom",
      label: "UOM",
      width: "0.8fr",
    },
    {
      key: "currentStock",
      label: "Current Stock",
      width: "0.9fr",
      render: (row) => (
        <input
          type="text"
          placeholder="Eg: 10"
          value={stockCounts[row?.batchSessionId] || ""}
          onChange={(e) => handleStockChange(row?.batchSessionId, e.target.value)}
          className="edc-stock-input"
        />
      ),
    },
  ];

  // ── OLD DataGrid columns — kept for reference ─────────────────────────────
  // const columns = [
  //   { field: "productName", headerName: "Product Name", minWidth: 200, flex: 0.75, headerClassName: "datagrid-columns", headerAlign: "center", cellClassName: "datagrid-rows", align: "left" },
  //   { field: "uom", headerName: "UOM", minWidth: 100, flex: 0.75, headerClassName: "datagrid-columns", headerAlign: "center", cellClassName: "datagrid-rows", align: "center" },
  //   { field: "batch", headerName: "Batches", minWidth: 150, flex: 0.75, headerClassName: "datagrid-columns", headerAlign: "center", cellClassName: "datagrid-rows", align: "center" },
  //   {
  //     field: "actions", headerName: "Current Stock", minWidth: 150, flex: 0.75, headerClassName: "datagrid-columns", headerAlign: "center", cellClassName: "datagrid-rows", align: "center",
  //     renderCell: (params) => (
  //       <input type="text" placeholder="Eg: 10" value={stockCounts[params.row?.batchSessionId] || ""} onChange={(e) => handleStockChange(params.row?.batchSessionId, e.target.value)} className="stock-input" />
  //     ),
  //   },
  // ];

  const handleStockChange = (batchSessionId, value) => {
    setStockCounts((prev) => ({
      ...prev,
      [batchSessionId]: value,
    }));
  };

  const filteredData = pageState.dataRows?.filter((item) =>
    item?.productName?.toLowerCase().includes(debouncedSearchTerm?.toLowerCase())
  );

  // Count how many rows have a stock value entered (for progress badge)
  const updatedCount = Object.values(stockCounts || {})?.filter((v) => v !== "")?.length;
  const totalRows = pageState?.total;

  const clearLocalStorageData = () => {
    localStorage.clear();
  };

  const handleEndDayWithoutReport = () => {
    setEndDayModalOpen(false);
    setEndDayLoading(true);
    performCloseDay();
  };

  const handleEndDayWithReport = () => {
    setEndDayModalOpen(false);
    setLoading(true);
    const isInventoryConfigSet = localStorage.getItem("isInventoryConfigSet");

    getEndDayReportData(locId, orgId)
      .then((response) => {
        if (response?.data?.data?.es > 0) {
          showSnackbar("Error while generating report", "error");
          setLoading(false);
          return;
        }
        const dataToprint = response?.data?.data;
        setTimeout(() => {
          startPrint({
            productData: dataToprint,
            printType: "end-report",
            onPrintComplete: () => {
              setLoading(false);

              // if (isInventoryConfigSet) {
              //   navigate("/session-page/day/closing/end");
              // } else {
              //   newSwal
              //     .fire({
              //       title: "Do you want to close the day?",
              //       icon: "question",
              //       showCancelButton: true,
              //       confirmButtonText: "Yes, Close day",
              //       cancelButtonText: "No",
              //       backdrop: "rgba(0,0,0,0.4)",
              //     })
              //     .then((result) => {
              //       if (result.isConfirmed) {
              //         handleCloseDay();
              //       }
              //     });
              // }
              setEndDayLoading(true);
              performCloseDay();
            },
            onPrintError: () => {
              setLoading(false);
              showSnackbar("Failed to print report", "error");
            },
          });
        }, 100);
      })
      .catch((error) => {
        setLoading(false);
        showSnackbar("Failed to fetch report data", "error");
      });
  };

  // this is the new code for the end of day with report with usb printer
  // const handleEndDayWithReport = () => {
  //   setEndDayModalOpen(false);
  //   setLoading(true);

  //   const printerConfig = localStorage.getItem("printerConfig");
  //   const parsedConfig = printerConfig ? JSON.parse(printerConfig) : null;
  //   const isUSBPrinter =
  //     !parsedConfig ||
  //     (parsedConfig?.label !== "Bluetooth" && parsedConfig?.label !== "Serial port");

  //   let usbReady = Promise.resolve();
  //   if (isUSBPrinter && !localStorage.getItem("savedUSBPrinterDevice")) {
  //     usbReady = navigator.usb.requestDevice({ filters: [{ classCode: 7 }] }).then((device) => {
  //       dispatch(setUSBDevice(device));
  //       localStorage.setItem(
  //         "savedUSBPrinterDevice",
  //         JSON.stringify({ vendorId: device?.vendorId, productId: device?.productId })
  //       );
  //     });
  //   }

  //   getEndDayReportData(locId, orgId)
  //     .then(async (response) => {
  //       if (response?.data?.data?.es > 0) {
  //         showSnackbar("Error while generating report", "error");
  //         setLoading(false);
  //         return;
  //       }

  //       const deviceOk = await usbReady
  //         .then(() => true)
  //         .catch(() => {
  //           showSnackbar("Printer selection cancelled", "error");
  //           setLoading(false);
  //           return false;
  //         });
  //       if (!deviceOk) return;

  //       const dataToprint = response?.data?.data;
  //       setTimeout(() => {
  //         startPrint({
  //           productData: { data: dataToprint },
  //           printType: "end-report",
  //           onPrintComplete: () => {
  //             setLoading(false);
  //             setEndDayLoading(true);
  //             performCloseDay();
  //           },
  //           onPrintError: () => {
  //             setLoading(false);
  //             showSnackbar("Failed to print report", "error");
  //           },
  //         });
  //       }, 100);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       showSnackbar("Failed to fetch report data", "error");
  //     });
  // };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 420,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 3,
  };

  const handleCloseDay = () => {
    setEndDayModalOpen(true);
  };

  const performCloseDay = async () => {
    const payload = {
      sessionId: daySessionId,
      updatedBy: retailUserLocalStorageData?.uidx,
    };

    try {
      const closeRes = await closeDay(payload);

      showSnackbar("Day closed successfully", "success");

      newSwal.fire({
        title: "Day Closed!",
        text: "The day has been closed successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      const closeHoldCardResponse = await closeAllCarts({
        locationId: locId,
        // loggedInUserId: retailUserLocalStorageData?.uidx,
        // terminalName: licenseId,
      });

      // if (closeHoldCardResponse?.data?.data?.es > 0) {
      showSnackbar(
        closeHoldCardResponse?.data?.data?.message || "Error closing hold carts",
        "success"
      );
      // return;
      // }

      clearLocalStorageData();
      // setTimeout(() => {
      // window.location.href = "/";
      navigateToPath("/");
      // }, 1500);
    } catch (err) {
      showSnackbar("There was an error closing the day", "error");
    }
  };

  const handleUpdateStockCount = () => {
    // Prepare data for submission
    const stockCountData = Object.entries(stockCounts)?.map(([batchSessionId, count]) => ({
      batchSessionId,
      userQuantity: parseFloat(count) || 0,
      updatedBy: retailUserLocalStorageData?.uidx,
      updatedByName: retailUserLocalStorageData?.firstName,
    }));
    const batchPayload = {
      batchSessionUpdateRequestList: stockCountData,
    };

    // Submit stock count
    updateStockCount(batchPayload)
      .then((res) => {
        if (res?.data?.data?.es > 0 || res?.data?.data?.statusCode !== 200) {
          showSnackbar(
            res?.data?.data?.message || "There was an error creating stock count",
            "error"
          );
        } else {
          showSnackbar("Stock count updated successfully", "success");

          // Ask if they want to close the day after updating stock count
          newSwal
            .fire({
              title: "Do you want to close the day?",
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Yes, Close day",
              cancelButtonText: "No",
              backdrop: "rgba(0,0,0,0.4)",
            })
            .then((closeResult) => {
              if (closeResult.isConfirmed) {
                handleCloseDay();
              }
            });
        }
      })
      .catch((err) => {
        showSnackbar("There was an error creating stock count", "error");
      });
  };

  const handleSubmit = () => {
    if (enableMandatoryStockCount) {
      // If mandatory stock count is enabled, follow the original flow
      newSwal
        .fire({
          title: "Are you sure you want to update the stock count?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Proceed",
          cancelButtonText: "Cancel",
          backdrop: "rgba(0,0,0,0.4)",
        })
        .then((result) => {
          if (result.isConfirmed) {
            handleUpdateStockCount();
          }
        });
    } else {
      // If mandatory stock count is NOT enabled, ask what they want to do
      newSwal
        .fire({
          title: "What would you like to do?",
          text: "Do you want to update the stock count or just end the day?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Update Stock",
          cancelButtonText: "End Day", // Changed to "End Day"
          backdrop: "rgba(0,0,0,0.4)",
          allowOutsideClick: false, // Prevent closing by clicking outside
        })
        .then((result) => {
          if (result.isConfirmed) {
            // User chose to update stock count
            newSwal
              .fire({
                title: "Are you sure you want to update the stock count?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Proceed",
                cancelButtonText: "Cancel",
                backdrop: "rgba(0,0,0,0.4)",
              })
              .then((confirmResult) => {
                if (confirmResult.isConfirmed) {
                  handleUpdateStockCount();
                }
              });
          } else if (result.dismiss === newSwal.DismissReason.cancel) {
            // User chose to just end the day (clicked "End Day" button)
            newSwal
              .fire({
                title: "Are you sure you want to close the day?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Close Day",
                cancelButtonText: "Cancel",
                backdrop: "rgba(0,0,0,0.4)",
              })
              .then((confirmResult) => {
                if (confirmResult.isConfirmed) {
                  handleCloseDay();
                }
              });
          }
        });
    }
  };

  return (
    <div className="edc-layout">
      {/* ── Page header ───────────────────────────────────────────────────
      <div className="edc-page-header">
        <h4 className="edc-page-title">End Day</h4>
      </div>
      */}

      {/* ── Main card ─────────────────────────────────────────────────────── */}
      <div className="edc-card">
        {/* Card top: title + subtitle + progress badge + search */}
        <div className="edc-card-header">
          <div className="edc-card-title-group">
            <h2 className="edc-card-title">Closing Stock Capture</h2>
            <p className="edc-card-subtitle">
              Review counted inventory after manager authorization and enter the available quantity
              for each line item.
            </p>
          </div>

          <div className="edc-header-right">
            {/* Progress badge */}
            <div className="edc-progress-badge">
              <span className="edc-progress-label">Items updated</span>
              <span className="edc-progress-value">
                {updatedCount || 0}/{totalRows || 0}
              </span>
            </div>

            {/* Search */}
            {/* <div className="edc-search-box">
              <PosCustomIcon
                icon={<MagnifyingGlassIcon />}
                height="18px"
                width="18px"
                color="#94a3b8"
              />
              <input
                type="text"
                placeholder="Search products…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="edc-search-input"
              />
            </div> */}
          </div>
        </div>

        {/* ── Two-column body ────────────────────────────────────────────── */}
        <div className="edc-body-grid">
          {/* Left: table */}
          <div className="edc-table-wrapper">
            {/* OLD DataGrid block — replaced by CustomerPaginatedTable below */}
            {/* <Box>
              <Box sx={{ marginTop: "10px" }}>
                {pageState.loader ? (
                  <Box sx={{ height: "525px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spinner />
                  </Box>
                ) : (
                  <Box sx={{ height: "525px" }}>
                    <div tabIndex={-1}>
                      <DataGrid
                        rows={debouncedSearchTerm ? filteredData : pageState.dataRows}
                        columns={columns}
                        getRowId={(row) => row.id}
                        loading={pageState.loader}
                        rowCount={parseInt(pageState.total)}
                        pagination
                        page={pageState.page - 1}
                        pageSize={pageState.pageSize}
                        paginationMode="server"
                        onPageChange={(newPage) => { setPageState((old) => ({ ...old, page: newPage + 1 })); }}
                        disableSelectionOnClick
                        disableColumnMenu
                        autoHeight
                        getRowClassName={(params) =>
                          selectedRow?.length > 0 && (selectedRow[0] === params.row.id || selectedRow?.includes(params.row.id))
                            ? "selected-row" : ""
                        }
                        onSelectionModelChange={(newSelection) => { setSelectedRow(newSelection); }}
                        sx={{ border: "none" }}
                      />
                    </div>
                  </Box>
                )}
              </Box>
            </Box> */}

            <CustomerPaginatedTable
              columns={columns}
              rows={debouncedSearchTerm ? filteredData : pageState?.dataRows}
              loading={pageState?.loader}
              meta={{
                page: pageState?.page - 1,
                pageSize: pageState?.pageSize,
                totalResults: pageState?.total,
              }}
              onPageChange={(newPage) => setPageState((old) => ({ ...old, page: newPage + 1 }))}
              rowKey="id"
              emptyText="No products found."
            />
          </div>

          {/* Right: info sidebar */}
          <div className="edc-sidebar">
            <div className="edc-sidebar-card edc-sidebar-card--light">
              <div className="edc-sidebar-icon-wrap">
                {/* OLD: heroicons CubeIcon via PosCustomIcon — replaced with
                    the same inline "Boxes" svg used in the Replit reference,
                    same amber-600 (#d97706) color.
                <PosCustomIcon icon={<CubeIcon />} height="24px" width="24px" color="#d97706" />
                */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#d97706"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"></path>
                  <path d="m7 16.5-4.74-2.85"></path>
                  <path d="m7 16.5 5-3"></path>
                  <path d="M7 16.5v5.17"></path>
                  <path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"></path>
                  <path d="m17 16.5-5-3"></path>
                  <path d="m17 16.5 4.74-2.85"></path>
                  <path d="M17 16.5v5.17"></path>
                  <path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"></path>
                  <path d="M12 8 7.26 5.15"></path>
                  <path d="m12 8 4.74-2.85"></path>
                  <path d="M12 13.5V8"></path>
                </svg>
              </div>
              <div>
                <p className="edc-sidebar-card-title">Count the remaining stock</p>
                <p className="edc-sidebar-card-body">
                  Enter the available quantity exactly as counted on the floor or in the station
                  handover tray.
                </p>
              </div>
            </div>

            <div className="edc-sidebar-card edc-sidebar-card--dark">
              <p className="edc-sidebar-next-label">Next step</p>
              <p className="edc-sidebar-next-title">
                Close the day once all stock lines are captured.
              </p>
              <p className="edc-sidebar-next-body">
                This keeps inventory handover aligned with the day close checklist.
              </p>
            </div>
          </div>
        </div>

        {/* ── Footer actions ─────────────────────────────────────────────── */}
        {/* OLD action-buttons block (very first version):
        <div className="action-buttons">
          <PosCustomButton title="Cancel" variant="red-transparent" radius="4px" p={"8px 10px"} onClickFunction={() => navigateToPath(-1)} />
          <div>
            <PosCustomButton title="Submit" width="100%" p={"12px 16px"} radius="4px" variant="blue-d" onClickFunction={handleSubmit} />
          </div>
        </div> */}

        {/* OLD edc-footer block — used PosCustomButton + PosCustomIcon.
            Replaced below with plain <button>/<svg> markup so the footer
            matches the Replit reference exactly (and uses pure CSS only).
        <div className="edc-footer">
          <PosCustomButton
            title="Back"
            variant="custom-variant"
            radius="0.75rem"
            p="0.5rem 2rem 0.5rem 2rem"
            onClickFunction={() => navigate("END_OF_DAY_SUMMARY_PAGE")}
            iconOnLeft={
              <PosCustomIcon
                icon={<ArrowLeftIcon />}
                height={"16px"}
                width={"16px"}
                color="#0f1729"
              />
            }
            customBorder={"1px solid #cbd5e1"}
            customBackgroundColor={"white"}
            textColor={"#0f1729"}
          />
          <PosCustomButton
            title="Close Day"
            variant="blue-d"
            radius="0.75rem"
            p="0.5rem 2rem 0.5rem 2rem"
            disabled={updatedCount !== totalRows}
            onClickFunction={handleSubmit}
            iconOnRight={
              <PosCustomIcon
                icon={<ArrowRightIcon />}
                height={"16px"}
                width={"16px"}
                color="white"
              />
            }
          />
        </div>
        */}

        <div className="edc-footer">
          <button
            type="button"
            className="edc-btn edc-btn-back"
            data-testid="button-session-stock-back"
            onClick={() => navigate("END_OF_DAY_SUMMARY_PAGE")}
          >
            <svg
              className="edc-btn-icon edc-btn-icon-left"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            Back
          </button>

          <button
            type="button"
            className="edc-btn edc-btn-close-day"
            data-testid="button-session-stock-next"
            // disabled={updatedCount !== totalRows}
            onClick={handleSubmit}
          >
            Close Day
            <svg
              className="edc-btn-icon edc-btn-icon-right"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      {/* NEW MODAL FOR END DAY */}
      <Modal
        open={endDayModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="end-day-modal-title"
        aria-describedby="end-day-modal-description"
      >
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <span role="img" aria-label="sun" style={{ fontSize: "20px" }}>
                🌤️
              </span>
              <span style={{ fontSize: "18px", fontWeight: 600, color: "#1a1a1a" }}>
                How Do You Want To End The Day?
              </span>
            </Box>
            <IconButton onClick={handleCloseModal} size="small" sx={{ color: "#666" }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <p style={{ fontSize: "14px", color: "#666", margin: "0 0 24px 0" }}>
            Pick one of the options below to wrap up your day!
          </p>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <PosCustomButton
              title="End day without report"
              width="50%"
              p={"12px 16px"}
              radius="4px"
              variant="red-transparent"
              loading={endDayLoading}
              onClickFunction={handleEndDayWithoutReport}
            />
            <PosCustomButton
              title="End day with Report"
              width="50%"
              p={"12px 16px"}
              radius="4px"
              variant="blue-d"
              loading={loading}
              onClickFunction={handleEndDayWithReport}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default EndDayStockCount;
